import { useQuery, UseQueryOptions } from 'react-query';

import { fetchJson } from '@zapier/toolbox-browser-fetch';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

import useNotify from './useNotify';

const QUERY_KEY_PREFIX = 'query-subscribers';
const getQueryKey = (integrationId: string) =>
  `${QUERY_KEY_PREFIX}-${integrationId}`;

function useQuerySubscribers(
  integrationId: string,
  options?: UseQueryOptions<{ objects: any }>
) {
  const notify = useNotify();

  const queryKey = getQueryKey(integrationId);
  const url = new URL(
    `/api/platform/v3/integrations/${encodeURIComponent(
      integrationId
    )}/subscribers`,
    ZAPIER_APP_BASE_URL
  );

  const { data, error, ...rest } = useQuery(
    queryKey,
    () => fetchJson(url.href),
    options
  );

  if (error) {
    notify.failure('Failed to fetch subscribers.');
  }

  const subscribers = data?.objects ?? [];

  return { ...rest, subscribers, error, queryKey };
}

export default useQuerySubscribers;
export { getQueryKey, QUERY_KEY_PREFIX };
